import { useContext } from "react";

import { Context } from "../../store/teacher";

const useAppOrderStatus = () => {
  const { contextState } = useContext(Context);

  const hasG4sAndDlpOrder =
    contextState.has_g4s_order && contextState.has_dlp_order;

  const hasOnlyG4sOrder =
    contextState.has_g4s_order && !contextState.has_dlp_order;

  // 紙教材利用校はhas_dlp_orderがfalseになる可能性があるため判定要素に含めない
  const hasOnlyDlpOrder =
    !contextState.has_g4s_order && !contextState.has_g4s_basic_order;

  const hasDlpAndG4sBasicOrder =
    !contextState.has_g4s_order &&
    contextState.has_dlp_order &&
    contextState.has_g4s_basic_order;

  const hasOnlyG4sBasicOrder =
    !contextState.has_g4s_order &&
    !contextState.has_dlp_order &&
    contextState.has_g4s_basic_order;

  return {
    hasG4sAndDlpOrder,
    hasOnlyG4sOrder,
    hasOnlyDlpOrder,
    hasDlpAndG4sBasicOrder,
    hasOnlyG4sBasicOrder,
  };
};

export default useAppOrderStatus;
